import { ButtonDock } from '@focuslee/shared-mini-app';
import { Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import React, { useCallback, useState } from 'react';
import { Page } from '../Page';
import { TimeWheelPicker } from './TimeWheelPicker';

export interface TimePickerViewProps {
  initialTimeMs: number;
  onUpdate: (newTimeMs: number) => void;
  onCancel: () => void;
}

export const TimePickerView: React.FC<TimePickerViewProps> = ({ initialTimeMs, onUpdate, onCancel }) => {
  const totalSeconds = Math.floor(initialTimeMs / 1000);
  const [time, setTime] = useState({
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  });

  const handleSave = useCallback(() => {
    const newTimeMs = (time.hours * 3600 + time.minutes * 60 + time.seconds) * 1000;
    onUpdate(newTimeMs);
  }, [time, onUpdate]);

  return (
    <Page
      back={true}
      insetEnabled={false}
      backClick={onCancel}
      footer={
        <ButtonDock
          secondary={{ text: 'Cancel', onClick: onCancel }}
          main={{ text: 'Update Time', onClick: handleSave }}
        />
      }
    >
      <Stack alignItems="center" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
        <Text weight="2" style={{ fontSize: '18px' }}>
          Set Time
        </Text>
      </Stack>
      <Stack flexGrow={1} alignItems="center" justifyContent="center">
        <TimeWheelPicker
          hours={time.hours}
          minutes={time.minutes}
          seconds={time.seconds}
          onChange={setTime}
        />
      </Stack>
    </Page>
  );
};
